import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ContestWinnerModel } from '../../../galleryModule/models/contestWinner.model';
import { AppSettingsService } from '../../../../shared/services/appsettings.service';

@Component({
  selector: 'virtual-gallery',
  templateUrl: './virtual-gallery.component.html',
  styleUrls: ['./virtual-gallery.component.css']
})

export class VirtualGalleryComponent implements OnInit {

  @Input('contestWinners') contestWinners: ContestWinnerModel[];

  filteredContestWinners: ContestWinnerModel[];
  gradeCategoryId: number = 0;
  lastCompletedContestYear: number;

  constructor() {

  }

  ngOnInit() {
    this.filteredContestWinners = this.contestWinners;
    this.lastCompletedContestYear = AppSettingsService.settings.lastCompletedContestYear;
  }

  filterPictures(gradeCategoryId) {
    this.gradeCategoryId = gradeCategoryId;
    if (this.gradeCategoryId === 0)
      this.filteredContestWinners = this.contestWinners;
    else
      this.filteredContestWinners = _.filter(this.contestWinners, function (w) {
        if (w.gradeCategoryId == gradeCategoryId) return w;
      });
  }

}
